import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { ProductIndicatorBadge } from 'common';
import IndividualProgressIndicator from '../../../create-new-common/IndividualProgressIndicator';

const CheckboxIconStyled = styled(CheckBoxIcon)(({ theme }) => ({
  marginRight: theme.spacing(2),
}));

const ProductIndicator = styled(ProductIndicatorBadge)(({ theme }) => ({
  marginLeft: theme.spacing(2),
}));

const IndividualListing = ({ showProductIdentifier, completedListing, nameShort, proprietary }) => {
  const isSuccessful = !!completedListing?.successful;
  const errorMessage = completedListing?.error;
  return (
    <Box
      alignItems="center"
      display="flex"
      flexDirection="row"
      height={60}
      justifyContent="space-between"
      px={3}
      sx={{
        borderBottom: theme => `1px solid ${theme.palette.graphic.light}`,
      }}
    >
      <Box alignItems="center" color="graphic.main" display="flex" flexDirection="row">
        <CheckboxIconStyled color="inherit" />
        <Typography color="textPrimary" sx={{ paddingTop: '2px' }}>
          {nameShort}
        </Typography>
      </Box>
      <Box alignItems="center" display="flex" flexDirection="row">
        <IndividualProgressIndicator
          error={completedListing ? errorMessage || 'Could not process request for this item' : ''}
          isSuccessful={isSuccessful}
        />
        {showProductIdentifier && <ProductIndicator proprietary={proprietary} />}
      </Box>
    </Box>
  );
};

IndividualListing.propTypes = {
  completedListing: PropTypes.shape({
    // eslint-disable-next-line react/no-unused-prop-types
    error: PropTypes.string.isRequired,
    // eslint-disable-next-line react/no-unused-prop-types
    successful: PropTypes.bool.isRequired,
  }),
  nameShort: PropTypes.string.isRequired,
  proprietary: PropTypes.bool,
  showProductIdentifier: PropTypes.bool.isRequired,
};

IndividualListing.defaultProps = {
  completedListing: undefined,
  proprietary: undefined,
};

export default IndividualListing;
